<template>
  <div class="productList">
    <breadcrumb
      v-bind:path1="path1"
      v-bind:path2="path2 || this.currentDisplayGroup.category"
    ></breadcrumb>
    <!--子导航-->
    <!-- <div class="page-width">
      <div class="sonNav" v-if="sonNavList.length">
        <swiper :options="recommendedSwiper" ref="mySwiper">
          <swiper-slide v-for="(item, index) in sonNavList" v-bind:key="index" class="categoryBtn">
            <a style="max-width: 136px" @click="fetchSelectedCategories(item)">{{item.Name}}</a>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev el-icon-caret-left"></div>
        <div class="swiper-button-next el-icon-caret-right"></div> -->
    <!-- <ul class="hidden-md-and-down">
          <li v-for="(item, index) in sonNavList" @click="fetchSelectedCategories(item.ProductCategory_id)" v-bind:key="index">
            <a v-if='$i18n.locale=="en"'>{{item.Name}}</a>
            <a v-if='$i18n.locale=="ch"'>{{item.Description}}</a>
          </li>
        </ul> -->
    <!-- </div>
    </div> -->
    <!--end子导航-->

    <!--select order-->
    <div class="collection-header">
      <div class="group-description-wrapper page-width">
        <div
          v-if="this.currentDisplayGroup.title === 'SAKE & BEER'"
          class="sake-container"
        >
          <div class="icon-circle">
            <font-awesome-icon class="info-icon" icon="info" />
          </div>
          <p class="sake-beer-p">
            Sake and Beer can only be shipped to California residences but we
            are getting permits for other states soon
          </p>
        </div>
        <p
          v-if="this.currentDisplayGroup.title !== 'SAKE & BEER'"
          class="group-description-header"
        >
          {{ this.currentDisplayGroup.title }}
        </p>
        <p
          v-if="this.currentDisplayGroup.title !== 'SAKE & BEER'"
          class="group-description-body"
        >
          {{ this.currentDisplayGroup.description }}
        </p>
      </div>
      <div class="filters-toolbar-wrapper">
        <div class="page-width">
          <div class="filters-toolbar__item-child">
            <div
              class="filter"
              v-if="
                this.group.toLowerCase() !== 'smarts' &&
                this.group.toLowerCase() !== 'wants'
              "
            >
              <p>{{ $t("category") }} :</p>
              <el-select
                v-model="sonNavObj"
                value-key="Name"
                v-bind:placeholder="$t('pleaseSelectCategory')"
                @change="fetchSelectedCategories"
              >
                <el-option
                  v-for="item in sonNavList"
                  :key="item.value"
                  :label="item.Name"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
            <div class="filter">
              <p>{{ $t("sortBy") }} :</p>
              <el-select
                v-model="option"
                v-bind:placeholder="$t('pleaseSelectSortingMethod')"
                value=""
                @change="updateFilter"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end select order-->

    <!--列表主题-->
    <div v-if="this.isLoading" class="product-listing-container">
      <div class="page-width">
        <div class="loadmore disableBtn">
          <span>{{ $t("loadingProducts") }}</span>
          <i class="loading">
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
          </i>
        </div>
      </div>
    </div>
    <div v-if="!this.isLoading" class="product-listing-container">
      <div class="page-width">
        <ul v-if="this.list.length">
          <li
            v-for="(item, index) in list"
            v-bind:key="index"
            v-if="!item.IsStopSale"
          >
            <productCard
              v-if="$i18n.locale == 'en'"
              v-bind:img="item.ThumbnailLarge"
              v-bind:link="item.link"
              v-bind:name="item.Name"
              v-bind:isPromotion="item.IsPromotion"
              v-bind:price="item.Price"
              v-bind:item="item"
              v-bind:quantity="item.Quantity"
              v-bind:key="index"
            ></productCard>
            <productCard
              v-if="$i18n.locale == 'ch'"
              v-bind:img="item.ThumbnailLarge"
              v-bind:link="item.link"
              v-bind:name="item.Description"
              v-bind:isPromotion="item.IsPromotion"
              v-bind:price="item.Price"
              v-bind:item="item"
              v-bind:quantity="item.Quantity"
              v-bind:key="index"
            ></productCard>
          </li>
        </ul>
        <div v-else class="loadmore disableBtn">
          <span>{{ $t("noMoreProducts") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import breadcrumb from "@/components/breadcrumb";
import productCard from "./productCard";
import { groupDescData } from '../assets/js/groupDesc';
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart,
  flyToElement,
} from "../store/modules/cart";

export default {
  name: "productList",
  components: {
    breadcrumb,
    productCard,
  },
  metaInfo() {
    return {
      title: this.currentDisplayGroup.metaTitle,
      meta: [
        // {
        // name: 'description',
        // content: this.currentDisplayGroup.metaDescription,
      // }
    ]
    }
  },
  props: {
    group: {
      type: String,
    },
  },
  data() {
    return {
      isLoading: false,
      path1: {
        name: '',
        path: '/',
      },
      path2: '',
      chgroup: '',
      sonNavObj: {},
      sonNavList: [],
      // drop down filter
      option:"",
      options: [{
        value: '1',
        label: 'Alphabetically, A-Z'
      }, {
        value: '2',
        label: 'Alphabetically, Z-A'
      }, {
        value: '3',
        label: 'Price, low to high'
      }],
      recommendedSwiper: {
        slidesPerView: 5, // how many to shoe in a row
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        roundLengths : true,
        spaceBetween: 20,
        breakpoints: {
          320: { slidesPerView: 1 },
          480: { slidesPerView: 2 },
          768: { slidesPerView: 4 },
          990: { slidesPerView: 4 },
          1200: { slidesPerView: 4 },
          1280: { slidesPerView: 5 }
        }
      },
      list: [],
      listReg: [],
      listOut: [],
      catReg: [],
      catOut: [],
      inCart: null,
      currentGroup: [],
      groupId: null,
      currentDisplayGroup: {},
    }
  },
  methods: {
    ...mapActions('products',['fetchCategories', 'fetchProductsWithGroupId']),
    ...mapMutations('products', ['updateActiveProduct']),
    ...mapActions('cart', ['addProductToCart']),
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    isOutOfStock(item) {
      if(item.IsOverSaleable) {
        return false
      }
      return item.StockLevel > 0 ? false : true;
    },
    // Check if b2b items are out of stock so we sort them to the bottom.
    isOutOfStockBusiness(item) {
      let stock = item.StockLevel;
      let masterSoldout = true;
      let innerSoldout = true;

      // map through b2b items and check for proper casing. Add to hash map.
      if (item.MasterInner.length) {
        item.MasterInner.map(b2bCase => {
          let itemStock = stock/b2bCase.ConvertNum;
          if (b2bCase.ProductNum.charAt(item.MasterInner[0].ProductNum.length - 1) === "0") {
            if (itemStock>=1) {
              masterSoldout = false;
            }
          }
          if (b2bCase.ProductNum.charAt(item.MasterInner[0].ProductNum.length - 1) === "2") {
            if (itemStock>=1) {
              innerSoldout = false;
            }
          }
        });
      }

      if (masterSoldout && innerSoldout) {
        return true;
      } else {
        return false;
      }
    },
    sortSonNavList(list) {
      list = list.sort((a,b) => {
        return a.Name[0] > b.Name[0] ? 1 : -1;
      })
    },
    updateFilter(value) {
      if(value === '1') {
        this.list = this.list.sort((a,b) => {
          return a.Name[0] > b.Name[0] ? 1 : -1;
        })
      }
      if(value === '2') {
        this.list = this.list.sort((a,b) => {
          return a.Name[0] < b.Name[0] ? 1 : -1;
        })
      }
      if(value === '3') {
        this.list = this.list.sort((a,b) => {
          return a.Price - b.Price;
        })
      }
    },
    fetchSelectedCategories(item) {
      //console.log("item", item);
      this.isLoading = true;
      this.list = [];
      this.fetchCategories([item.ProductCategory_id, this.business])
      .then(res => {
        this.isLoading = false;
        let ctemp1 = [];
        let ctemp2 = [];
        let sortedDataStock = res.data.map((a) => {
          if (this.isOutOfStock(a)) {
            ctemp2.push(a)
          } else {
            ctemp1.push(a)
          }
        })
        this.catOut = ctemp2.sort((a,b)=>{
          return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        });
        this.catReg = ctemp1.sort((a,b) => {
          return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        })
        this.currentDisplayGroup['category'] = item.Name;
        // this.currentDisplayGroup['description'] = item.CategoryDescription;
        this.currentDisplayGroup['metaTitle'] = item.metaTitle;
        this.currentDisplayGroup['metaDescription'] = item.metaDescription;
        this.list = this.catReg.concat(this.catOut);
      })
      .catch(err => {
        console.log('err fetching product', err);
      })
    },
    fetchSelectedGroup(id) {
      let data = {
        id: id,
        isB2B: this.business
      }
      this.isLoading = true;
      this.sonNavObj = {};
      this.fetchProductsWithGroupId(data)
      .then(res => {
        this.isLoading = false;
        const temp1 = [];
        const temp2 = [];
        const sortedData = res.data.map((a)=>{
          if (this.business) {
            if (this.isOutOfStockBusiness(a)) {
              temp2.push(a)
            } else {
            temp1.push(a)
            }
          } else {
            if (this.isOutOfStock(a)) {
              temp2.push(a)
            } else {
              temp1.push(a)
            }
          }
        });
        this.listOut = temp2.sort((a,b)=>{
          return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        });
        this.listReg = temp1.sort((a,b)=>{
          return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
        });
        for ( var i = 0; i < groupDescData.length; i++ ) {
          if (groupDescData[i].group_id === id) {
            this.currentDisplayGroup['title'] = groupDescData[i].title;
            this.currentDisplayGroup['category'] = groupDescData[i].title;
            this.currentDisplayGroup['description'] = groupDescData[i].description;
            this.currentDisplayGroup['metaTitle'] = groupDescData[i].metaTitle;
            this.currentDisplayGroup['metaDescription'] = groupDescData[i].metaDescription;
          }
        }

        this.list = this.listReg.concat(this.listOut);
      })
      .catch(err => {
        this.isLoading = false;
        console.log('err', err)
      })
    },
    handleAddToCartSuccess(item) {
      this.$store.dispatch('cart/addCart', item);
    },
    handleAddToCartFail() {
      alert('no enought product in stock');
    },
    addToCart: function(item, event) {
      if (isUserAuthenticated()) {
        this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
        .then(() => {
        flyToElement(event.target, $('.cart-link'));
        })
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item)
        flyToElement(event.target, $('.cart-link'));
      }
    },
    goToProductDetail(product) {
      this.updateActiveProduct(product.ProductNum);
      // this.$router.push({ name: 'productDetails', params: { productNum: product.ProductNum} })
      this.$router.push({ path: '/productDetails', query: { productNum: product.ProductNum}})
    },
  },
  beforeRouteLeave(to, from, next) {
    if (isUserAuthenticated() && to.name === 'purchase') {
      this.$store.dispatch('cart/getCart')
      .then(() => {
      const cartItems = {};
      cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
      cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      cartItems.ShippingMethod = "Delivery";
      cartItems.Tip = 0;
      cartItems.TipPercentage = 0;
      cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
      this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
      .then(() => {
        this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
      })
      })
    }
    this.clearPromoCode();
    this.clearCard();
    next();
  },
  computed: mapState({
    allGroups: state => state.navbar.allGroups,
    activeCategory: state => state.products.activeCategory,
    activeProduct: state => state.products.activeProduct,
    product: state => state.products.productDetails[0],
    necessaryCartItems: state => state.cart.necessaryCartItems,
    itemCount: state => state.cart.itemCount,
    business: state => state.auth.userDetails.IsBusiness,
    userDetails: state => state.auth.userDetails,
    determineCase(item) {
      let properCase;
      if (item.MasterInner.length === 1) {
        item.MasterInner.map(container => {
          if (container.ProductNum.charAt(num.length - 1) === '0') {
            properCase = "master"
          }
          if (container.ProductNum.charAt(num.length - 1) === '2') {
            properCase = "inner"
          }
        });
      }
      if (item.MasterInner.length === 2) {
        properCase = "master";
      }
      return properCase;
    },
  }),
  watch: {
    '$route.query': {
      immediate: true,
      handler(groupVal) {
        if (this.$route.path == '/asian-food/noodles' || this.$route.path == '/collections/noodles') { groupVal.groupDesc = 'NOODLES'; }
        else if (this.$route.path == '/asian-food/snacks-candy' || this.$route.path == '/collections/munchies') { groupVal.groupDesc = 'MUNCHIES'; }
        else if (this.$route.path == '/asian-food/beverages' || this.$route.path == '/collections/dranks') { groupVal.groupDesc = 'DRANKS'; }
        else if (this.$route.path == '/asian-food/rice-grains' || this.$route.path == '/asian-food/sauces-seasoning' || this.$route.path == '/asian-food/grocery' || this.$route.path == '/collections/eats') { groupVal.groupDesc = 'EATS'; }
        else if (this.$route.path == '/books-paper/stationery-supplies' || this.$route.path == '/collections/smarts') { groupVal.groupDesc = 'SMARTS'; }
        else if (this.$route.path == '/collections/wants') { groupVal.groupDesc = ''; }
        else { groupVal.groupDesc = ''; }

        for ( var i = 0; i < groupDescData.length; i++ ) {
          if (groupDescData[i].title === groupVal.groupDesc) {
            this.currentDisplayGroup['title'] = groupDescData[i].title;
            this.currentDisplayGroup['category'] = groupDescData[i].title;
            this.currentDisplayGroup['description'] = groupDescData[i].description;
            this.currentDisplayGroup['metaTitle'] = groupDescData[i].metaTitle;
            this.currentDisplayGroup['metaDescription'] = groupDescData[i].metaDescription;

            const name = groupDescData[i].title;
            const path = name.toLowerCase();
            this.path1.name = name;
            this.path1.path = `/collections/${path}`;
          }
        }
      }
    },
    allGroups: function(newVal, oldVal) {
      const currentGroup = newVal.filter(group => {
        return group.Name.toLowerCase() === this.group.toLowerCase();
      });
      if(this.group.toLowerCase() !== 'smarts' && this.group.toLowerCase() !== 'wants') {
        this.sonNavList = currentGroup[0].Categories;
        if (this.group.toLowerCase() === 'munchies') {
          this.sonNavList = currentGroup[0].Categories.filter(category => {
            return (category.Name !== 'Kit Kat');
          });
        }
      }
      this.sortSonNavList(this.sonNavList);
      this.fetchSelectedGroup(currentGroup[0].ProductGroup_id);
    },
    group: function(newVal, oldVal) {
      const currentGroup = this.allGroups.filter(group => {
        return newVal === group.Name.toLowerCase();
      });
      if (currentGroup) {
        this.chgroup = currentGroup[0].Description;
        const name = currentGroup[0].Name;
        const path = name.toLowerCase();
        this.path1.name = name;
        this.path1.path = `/collections/${path}`;
      };

      this.option = '';
      this.sonNavObj = {};
      this.sonNavList = [];
      if(this.group.toLowerCase() !== 'smarts' && this.group.toLowerCase() !== 'wants') {
        this.sonNavList = currentGroup[0].Categories;
        if (this.group.toLowerCase() === 'munchies') {
          this.sonNavList = currentGroup[0].Categories.filter(category => {
            return (category.Name !== 'Kit Kat');
          });
        }
      }
      this.sortSonNavList(this.sonNavList);
      this.fetchSelectedGroup(currentGroup[0].ProductGroup_id);
    },
    'userDetails.IsBusiness': {
      handler: function(newVal, oldVal) {
        const currentGroup = this.allGroups.filter(group => {
          return this.group === group.Name.toLowerCase();
        });
        if (currentGroup[0]) {this.chgroup = currentGroup[0].Description;}
        if(this.group.toLowerCase() !== 'smarts' && this.group.toLowerCase() !== 'wants' && currentGroup[0]) {
          this.sonNavList = currentGroup[0].Categories;
          if (this.group.toLowerCase() === 'munchies') {
            this.sonNavList = currentGroup[0].Categories.filter(category => {
              return (category.Name !== 'Kit Kat');
            });
          }
        }
        this.sortSonNavList(this.sonNavList);
        if (currentGroup[0]) {
          this.fetchSelectedGroup(currentGroup[0].ProductGroup_id);
        }
        deep: true
      }
    }
  },
  mounted: function() {
    // check it is all empty
    this.$root.fetchSelectedGroup = this.fetchSelectedGroup.bind(this);
    const currentGroup = this.allGroups.filter(group => {
      if (this.group === 'sake+&+beer') {
        return group.Name.toLowerCase() === 'sake & beer';
      }
      return this.group === group.Name.toLowerCase();
    });
    if (currentGroup[0]) {this.chgroup = currentGroup[0].Description;}
    if(this.group.toLowerCase() !== 'smarts' && this.group.toLowerCase() !== 'wants' && this.currentGroup[0]) {
      this.sonNavList = currentGroup[0].Categories;
      if (this.group.toLowerCase() === 'munchies') {
        this.sonNavList = currentGroup[0].Categories.filter(category => {
          return (category.Name !== 'Kit Kat');
        });
      }
    }
    this.sortSonNavList(this.sonNavList);
    if (currentGroup[0]) {
      this.fetchSelectedGroup(currentGroup[0].ProductGroup_id);
    }
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/productList.less";
</style>



// WEBPACK FOOTER //
// src/view/productList.vue